import { getFaqs_listFaqCategories } from '../../services/types/getFaqs'

export const getFaqCategories = (faqData: getFaqs_listFaqCategories[]) => {
  return faqData?.map(item => {
    return item.name
  })
}

export const getQuestionsAndAnswers = (faqData: getFaqs_listFaqCategories[], categoryName: string) => {
  const categoryObj: getFaqs_listFaqCategories = faqData?.filter(item => item.name === categoryName)[0]
  return categoryObj?.questions
}
